import { Field } from '@atlaskit/form';
import { Inline, Text } from '@atlaskit/primitives/compiled';
import Select, { type OptionType, type ValueType } from '@atlaskit/select';
import React from 'react';
import { useIntl } from 'react-intl';

import { renderCustomFieldIcon } from '../utils';

import { messages } from './messages';

import type { StringOption } from '../types';

type PeopleFormatSelectProps = {
	mode: 'create' | 'edit';
	initialValue?: ValueType<StringOption> | null;
};

export const PeopleFormatSelect = ({ mode, initialValue }: PeopleFormatSelectProps) => {
	const intl = useIntl();
	const formatOptions = [
		{
			label: intl.formatMessage(messages.formatIndividuals),
			value: 'USER',
			icon: renderCustomFieldIcon('USER'),
		},
		{
			label: intl.formatMessage(messages.formatTeam),
			value: 'TEAM',
			icon: renderCustomFieldIcon('TEAM'),
		},
	];

	const resolvedDefaultValue = initialValue
		? (() => {
				const match = formatOptions.find(option => option.value === (initialValue as StringOption)?.value);
				return match ? { label: match.label, value: match.value } : null;
			})()
		: null;

	return (
		<Field<ValueType<OptionType>>
			name="peopleFormat"
			label={intl.formatMessage(messages.formatLabel)}
			defaultValue={resolvedDefaultValue}
			isRequired
		>
			{({ fieldProps }) => (
				<Select
					{...fieldProps}
					options={formatOptions}
					isDisabled={mode === 'edit'}
					placeholder={intl.formatMessage(messages.formatPlaceholder)}
					formatOptionLabel={(option, { context }) => (
						<Inline space="space.100" alignBlock="center">
							{option.icon}
							<Text color={context === 'value' ? 'color.text.subtlest' : undefined}>{option.label}</Text>
						</Inline>
					)}
				/>
			)}
		</Field>
	);
};
